import React, { Component, createRef } from "react";
import {
  POST,
  loading,
  token,
  alert,
  tokens,locale
} from "../components/CustomComponent.js";
import Navbar from "../components/Navbar.js";
import Footer from "../components/Footer.js";
import THUMBNAIL from "../assets/images/thumbnail.png";
import "../assets/css/bootstrap.css";
import "../assets/css/style.css";
export default class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      photo_standards: "",
      title_standards: "",
      message_standards: "",
      title_standards_2: "",
      message_standards_2: "",
      title_standards_3: "",
      message_standards_3: "",
    };
  }
  componentDidMount = async () => {
    loading(false);
      this.Get();
  };
  Get = async () => {
    loading(true);let result = null;
    let response = await fetch(process.env.REACT_APP_API_URL + "/updated.json");
    let update = await response.json();
    if (
      !tokens ||
      (tokens && tokens?.updated?.last_update !== update.last_update)
    ) {
    let response = await fetch(process.env.REACT_APP_API_URL + "/.json");
    result = await response.json();
    localStorage.setItem("scp-acc-tk", JSON.stringify(result));}else{
      result = tokens;
    }
    this.setState({
      photo_standards: result?.setting?.photo_standards,
       title_standards: result?.setting[`${locale}_title_standards`] || result?.setting?.th_title_standards,
        message_standards: result?.setting[`${locale}_message_standards`] || result?.setting?.th_message_standards,
        title_standards_2: result?.setting[`${locale}_title_standards_2`] || result?.setting?.th_title_standards_2,
        message_standards_2: result?.setting[`${locale}_message_standards_2`] || result?.setting?.th_message_standards_2,
        title_standards_3: result?.setting[`${locale}_title_standards_3`] || result?.setting?.th_title_standards_3,
        message_standards_3: result?.setting[`${locale}_message_standards_3`] || result?.setting?.th_message_standards_3,
     });
    loading(false);
  };
  render() {
    const {
      photo_standards,
      title_standards,
      message_standards,
      title_standards_2,
      message_standards_2,
      title_standards_3,
      message_standards_3,
    } = this.state;
    return (
      <div className="w-100 min-vh-100 bg-light position-relative">
        <Navbar />

        {/* SECTION 1 */}
        <div
          className="w-100 text-white position-relative"
          style={{
            minHeight: 350,
            backgroundImage: `url(${require("../assets/images/bg-3.jpg")})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
          }}
        >
          <div
            className="text-center p-5 position-relative"
            style={{
              minHeight: 350,
            }}
          >
            <div className="w-100 d-flex justify-content-center mt-4">
              <div
                className="px-3 py-5 mt-4 rounded"
                style={{
                  backgroundColor: "rgba(0,0,0,0.3)",
                  maxWidth: 500,
                  minWidth: 300,
                  width: "70%",
                  backdropFilter: "blur(10px)",
                  WebkitBackdropFilter: "blur(10px)", // Safari
                }}
              >
                <h1 className="fw-bold mb-2">มาตรฐานและงานวิจัย</h1>
              </div>
            </div>
          </div>
        </div>
        {/* SECTION 2 */}
        <div className="w-100">
           <div className="row bg-secondary-light">
              <div className="col-12 col-md-6 col-lg-6">
                <div
                  className="d-none d-md-block position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to left,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
                <div
                  className="d-block d-md-none position-relative align-content-center"
                  style={{
                    minHeight: 600,
                    backgroundImage: `
                      linear-gradient(to bottom,
                        rgba(234, 236, 243,1),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0),
                        rgba(234, 236, 243,0.2),
                        rgba(234, 236, 243,1)
                      ),
                      url(${photo_standards || THUMBNAIL})
                    `,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat",
                  }}
                />
              </div>

              <div className="col-12 col-md-6 col-lg-6 text-start px-5">
                <div className="my-5 py-4">

                  <h2 className="fw-bold mb-4">{title_standards}</h2>
                  <div className="text-secondary">{message_standards}</div>
                  <div className="mt-3">
                    <button
                      className="btn btn-primary px-3 mb-3 mx-2"
                      onClick={() => { window.open("https://asiaecoearth.com/wp-content/uploads/2025/01/%E0%B8%81%E0%B8%B2%E0%B8%A3%E0%B8%AD%E0%B8%AD%E0%B8%81%E0%B9%81%E0%B8%9A%E0%B8%9A%E0%B9%81%E0%B8%A5%E0%B8%B0%E0%B8%9E%E0%B8%B1%E0%B8%92%E0%B8%99%E0%B8%B2%E0%B9%80%E0%B8%95%E0%B8%B2%E0%B9%80%E0%B8%9C%E0%B8%B2%E0%B8%82%E0%B8%A2%E0%B8%B0%E0%B8%8A%E0%B8%B8%E0%B8%A1%E0%B8%8A%E0%B8%99%E0%B9%82%E0%B8%94%E0%B8%A2%E0%B9%83%E0%B8%8A%E0%B9%89%E0%B8%A7%E0%B8%B4.pdf","_blank")}}
                    >
                      <b className="icon me-2">{"\uf019"}</b>
                      ดาวน์โหลดงานวิจัย
                    </button>
                    <br/>
                    <button
                      className="btn btn-success px-3 mb-3 mx-2"
                      onClick={() => { window.open("https://asiaecoearth.com/wp-content/uploads/2025/01/cert2023.pdf","_blank") }}
                    >
                      <b className="icon me-2">{"\uf279"}</b>
                      Bureau Veritas Certification ISO 9001:2015
                    </button>
                  </div>
                </div>
              </div>
            </div>
          <div className="py-5">
            <div className="row mx-0">
              <div className="col-12 mb-4">
                <div className="bg-primary-light p-4 rounded-4">
                  <h4 className="fw-bold mb-2 text-primary text-center">{title_standards_2}</h4>
                  <div className="text-secondary px-4">
                    {message_standards_2.split("\n").map((item) => (
                      <div>{item}</div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-12 mb-4">
                <div className="p-4 rounded-4">
                <h4 className="fw-bold mb-2 text-primary">{title_standards_3}</h4>
                <div className="text-secondary px-4">
                  {message_standards_3.split("\n").map((item) => (
                    <div>{item}</div>
                  ))}
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="hpx-30"></div>
        <Footer />
      </div>
    );
  }
}
